import Modal from "./modal";
import { ModalContent, ModalFooter, ModalHeader } from "./modalElements";

export { ModalHeader, ModalContent, ModalFooter };
export default Modal;
